import {Button} from '@components/common/button/button'
import {withDefaultProps} from '@containers/with-props'
import tw from 'tailwind-styled-components'

const ButtonWithCustomBg = withDefaultProps(Button, {
  $bgClassName: 'bg-main-old',
  $textClassName: 'text-main-old'
})
export const TwCancelButton = tw(ButtonWithCustomBg)`
  border
  border-solid
  border-lists-divider-old
  text-main-old
  hover:text-bg-main-old
  hover:bg-secondary
`
